import { ReleaseVersionAudioData } from 'types/releases';
import { DisabledAudios } from 'types/general.types';
import { PreferredAudioSelectionOption } from './types';

export const getAudioOptions = (
  audioData: ReleaseVersionAudioData,
  disabledAudios?: DisabledAudios
): PreferredAudioSelectionOption[] =>
  audioData.items.map((audio) => ({
    title: audio.title,
    value: audio.guid,
    audioData: {
      ...audio,
      isLatestVersion: audioData.latestAudioGuid === audio.guid,
    },
    disabledTooltip: disabledAudios?.audios.includes(audio.guid as string)
      ? disabledAudios?.reason
      : '',
    isValid: audio.validationResult ? audio.validationResult.isValid : true,
  }));
